import { createContext, useContext, useLayoutEffect, useRef } from 'react';
export const ChromeContext = createContext(null);

// Pages declare their header; AppChrome owns its actual mounted instance.
export function useChromeHeader(kind, props) {
  const host = useContext(ChromeContext);
  const id = useRef({});
  const previous = useRef(null);
  useLayoutEffect(() => {
    if (!host) return;
    const old = previous.current;
    // Callback props routinely get fresh identities on page renders. Updating their refs
    // doesn't require repainting the chrome (and mustn't create a layout-effect loop).
    const changed = !old || Object.keys(props).some(key => typeof props[key] !== 'function' && old[key] !== props[key]);
    previous.current = props;
    if (changed) {
      const live = { ...props };
      Object.keys(props).forEach(key => { if (typeof props[key] === 'function') live[key] = (...args) => previous.current[key]?.(...args); });
      host.setHeader({ id: id.current, kind, props: live });
    }
  });
  useLayoutEffect(() => {
    if (!host) return undefined;
    const owner = id.current;
    return () => {
      previous.current = null;
      host.setHeader(current => current?.id === owner ? null : current);
    };
  }, [host]);
  return !!host;
}
